import { render } from "./AssignedClientUsersTable.vue?vue&type=template&id=e60a6f66&ts=true"
import script from "./AssignedClientUsersTable.vue?vue&type=script&lang=ts"
export * from "./AssignedClientUsersTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd});
